import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { IContactCategory } from "src/domain/entities"
import { contactCategoryDeleteService } from "src/domain/services/contactCategory/contactCategoryDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	contactCategory: IContactCategory
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const ContactCategoryDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	contactCategory,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleContactCategoryDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await contactCategoryDeleteService({ id: contactCategory.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [contactCategory, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete ContactCategory: ${contactCategory.name}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleContactCategoryDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
